
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gn6Is_45sYO2hvzclKZFmWXFTNHDvrIM5jJm3jXXc5bzY4Meta } from "/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexdvy_45aM4pI6n2KWYG1rP3MNDJivX6ArUA1_45_WWO_450hnoMeta } from "/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search3OdWVVuGLkohCVgZPF_9X_o2Ig7_45o_ShV0thzvTbGccMeta } from "/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexE9zbYpG7rnzHjPyBfQvMRQgYxJyQs_45hkebGghQBC_45BwMeta } from "/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93EcVOHorNJD7fUiVKYqIobNRNzXMjfg7BTTO_YGVa0m4Meta } from "/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexag3BngcZpde9WVHNdL2_sVB71zpyG1ZmjB_45oRhgLC6wMeta } from "/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93r9Rk4XMEIJmAq27wY7eWfWOaFrhwC9kx4Hiu6Uuy_45s8Meta } from "/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexOVarKjc2OddeOGaHmoItrNt4HJndkFnKN73KfEJv4jcMeta } from "/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93CLyBoCr_Aurc0UBZ5Skwr_F6EW0euV8H0TW0q_1yT6oMeta } from "/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexHsZ23hyAIv_3GM1bn1R4V4ERMtp6XnO9Cdvf2c7cIysMeta } from "/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexeyJ_45tqHVDczNjCAc8X6IoostFeOwAldsjYrH9_452gQxoMeta } from "/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexag3BngcZpde9WVHNdL2_sVB71zpyG1ZmjB_45oRhgLC6wMeta || {},
    component: () => import("/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexOVarKjc2OddeOGaHmoItrNt4HJndkFnKN73KfEJv4jcMeta || {},
    component: () => import("/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexHsZ23hyAIv_3GM1bn1R4V4ERMtp6XnO9Cdvf2c7cIysMeta || {},
    component: () => import("/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexeyJ_45tqHVDczNjCAc8X6IoostFeOwAldsjYrH9_452gQxoMeta || {},
    component: () => import("/codebuild/output/src250648735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]